import Vue from 'vue'
import VueRouter from 'vue-router'

import Error404 from '../views/404.vue'

import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import ForgotPasswordConfirm from '../views/ForgotPasswordConfirm.vue'
import ResetPassword from '../views/ResetPassword.vue'
import SuccessResetPassword from '../views/SuccessResetPassword.vue'

// Expedition
import ExpeditionIndex from '@/views/expedition/Index'
import ExpeditionAdd from '@/views/expedition/Add'
import ExpeditionDetail from '@/views/expedition/Detail'

// Delivery
import DeliveryIndex from '@/views/delivery/Index'
import DeliveryAdd from '@/views/delivery/Add'
import DeliveryDetail from '@/views/delivery/Detail'

// Contact
import ContactIndex from '@/views/contact/Index'
import ContactAdd from '@/views/contact/Add'
import ContactEdit from '@/views/contact/Edit'

// Price
import PriceIndex from '@/views/price/Index'
import PriceAdd from '@/views/price/Add'
import PriceEdit from '@/views/price/Edit'

// Device
import DeviceIndex from '@/views/device/Index'
import DeviceAdd from '@/views/device/Add'
import DeviceEdit from '@/views/device/Edit'

// Driver
import DriverIndex from '@/views/driver/Index'
import DriverAdd from '@/views/driver/Add'
import DriverEdit from '@/views/driver/Edit'

// Vehicle
import VehicleIndex from '@/views/vehicle/Index'
import VehicleAdd from '@/views/vehicle/Add'
import VehicleEdit from '@/views/vehicle/Edit'

//Report
import Report from '../views/report/Report.vue'

//Setting
import Setting from '../views/Setting.vue'

Vue.use(VueRouter)

const routes = [{
        path: 'main',
        component: () =>
            import ('../layouts/Main.vue'),
        children: [{
                path: '/404',
                name: 'Error404',
                component: Error404,
                meta: {
                    requiresAuth: true
                }
            },{
                path: '/dashboard',
                name: 'Home',
                component: Home,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/expedition',
                name: 'ExpeditionIndex',
                component: ExpeditionIndex,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/expedition/add/:type',
                name: 'ExpeditionAdd',
                component: ExpeditionAdd,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/expedition/:id/detail',
                name: 'ExpeditionDetail',
                component: ExpeditionDetail,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/shipment',
                name: 'DeliveryIndex',
                component: DeliveryIndex,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/shipment/add/:type',
                name: 'DeliveryAdd',
                component: DeliveryAdd,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/shipment/:id/detail',
                name: 'DeliveryDetail',
                component: DeliveryDetail,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/contact',
                name: 'ContactIndex',
                component: ContactIndex,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/contact/add',
                name: 'ContactAdd',
                component: ContactAdd,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/contact/:id/edit',
                name: 'ContactEdit',
                component: ContactEdit,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/price',
                name: 'PriceIndex',
                component: PriceIndex,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/price/add',
                name: 'PriceAdd',
                component: PriceAdd,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/price/:id/edit',
                name: 'PriceEdit',
                component: PriceEdit,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/device',
                name: 'DeviceIndex',
                component: DeviceIndex,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/device/add',
                name: 'DeviceAdd',
                component: DeviceAdd,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/device/:id/edit',
                name: 'DeviceEdit',
                component: DeviceEdit,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/driver',
                name: 'DriverIndex',
                component: DriverIndex,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/driver/add',
                name: 'DriverAdd',
                component: DriverAdd,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/driver/:id/edit',
                name: 'DriverEdit',
                component: DriverEdit,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/vehicle',
                name: 'VehicleIndex',
                component: VehicleIndex,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/vehicle/add',
                name: 'VehicleAdd',
                component: VehicleAdd,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/vehicle/:id/edit',
                name: 'VehicleEdit',
                component: VehicleEdit,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/report',
                name: 'Report',
                component: Report,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/setting',
                name: 'Setting',
                component: Setting,
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '',
        component: () =>
            import ('../layouts/FullPage.vue'),
        children: [{
                path: '/',
                name: 'Login',
                component: Login,
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/lupa-password',
                name: 'ForgotPassword',
                component: ForgotPassword,
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/lupa-password-confirm',
                name: 'ForgotPasswordConfirm',
                component: ForgotPasswordConfirm,
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/reset-password',
                name: 'ResetPassword',
                component: ResetPassword,
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/success-reset-password',
                name: 'SuccessResetPassword',
                component: SuccessResetPassword,
                meta: {
                    requiresAuth: false
                }
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    linkExactActiveClass: "active",
    linkActiveClass: "active"
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (localStorage.getItem('token') && localStorage.getItem('token') != 'null') {
            next()
        } else {
            next({
                path: '/'
            })
        }
    } else {
        next()
    }
})

export default router